/**
 * Global error handler to catch and log React context errors
 */

// Setup global error handlers
export function setupGlobalErrorHandlers() {
  // Log all unhandled errors
  window.onerror = function(message, source, lineno, colno, error) {
    console.error('=== GLOBAL ERROR HANDLER ===');
    console.error('Message:', message);
    console.error('Source:', source);
    console.error('Line:', lineno);
    console.error('Column:', colno);
    console.error('Error object:', error);
    
    // Check if this is a React context error
    if (message && typeof message === 'string' && 
        (message.includes('createContext') || message.includes('React'))) {
      console.error('=== REACT CONTEXT ERROR DETECTED ===');
      console.error('React global:', typeof window.React !== 'undefined' ? 'Available' : 'Not available');
      if (window.React) {
        console.error('React version:', window.React.version);
        console.error('createContext available:', typeof window.React.createContext === 'function');
      }
      
      // Log all React-related globals
      console.error('All React-related globals:');
      for (const key in window) {
        if (key.includes('React') || key.includes('react')) {
          console.error(`- ${key}:`, typeof window[key]);
        }
      }
      
      // Log module information if available
      if (source && typeof source === 'string') {
        console.error('Module path:', source);
        console.error('Is chunk file:', source.includes('chunk-'));
      }
    }
    
    return false; // Let the default handler run
  };
  
  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', function(event) {
    console.error('=== UNHANDLED PROMISE REJECTION ===');
    console.error('Reason:', event.reason);
    
    if (event.reason && event.reason.message && 
        typeof event.reason.message === 'string' && 
        (event.reason.message.includes('createContext') || event.reason.message.includes('React'))) {
      console.error('=== REACT CONTEXT ERROR IN PROMISE ===');
      console.error('React global:', typeof window.React !== 'undefined' ? 'Available' : 'Not available');
    }
  });
  
  console.log('Global error handlers have been set up');
}

// Export a function to manually log React status
export function logReactStatus() {
  console.log('=== REACT STATUS CHECK ===');
  console.log('React global:', typeof window.React !== 'undefined' ? 'Available' : 'Not available');
  
  if (window.React) {
    console.log('React version:', window.React.version);
    console.log('createContext available:', typeof window.React.createContext === 'function');
    
    // Test creating a context
    try {
      const TestContext = window.React.createContext(null);
      console.log('Context creation test:', TestContext ? 'Success' : 'Failed');
    } catch (error) {
      console.error('Context creation test failed:', error);
    }
  }
  
  return typeof window.React !== 'undefined' && typeof window.React.createContext === 'function';
}

// Declare global types
declare global {
  interface Window {
    React: typeof import('react');
    ReactDOM: typeof import('react-dom');
    ReactDOMClient: typeof import('react-dom/client');
    __REACT_INIT_TIMESTAMP__: number;
    __DEBUG_REACT_CONTEXT__: boolean;
  }
}
